/** Ролик «Векторные данные»: постер — первый кадр, размер как у видео */
export const MAP_ANIMATION_VIDEO = {
  src: 'videos/vectormaps-map-animation.mp4',
  posterSrc: '/images/video-posters/vectormaps-map-animation.png',
  width: 1168,
  height: 624,
};

export const mapLayers = [
  {
    titleKey: 'dataLayersBaselayersItem1',
    value: '1',
    image: 'layer1Img',
  },
  {
    titleKey: 'dataLayersBaselayersItem2',
    value: '2',
    image: 'layer2Img',
  },
  {
    titleKey: 'dataLayersBaselayersItem3',
    value: '3',
    image: 'layer3Img',
  },
  {
    titleKey: 'dataLayersBaselayersItems4',
    value: '4',
    image: 'layer4Img',
  },
  {
    titleKey: 'dataLayersBaselayersItems5',
    value: '5',
    image: 'layer5Img',
  },
];

export const additionalLayers = [
  {
    titleKey: 'dataLayersAdditionallayersItems1',
    value: '6',
    tooltipContentKey: 'dataAdditionalLayersTooltip1',
    image: 'layer6Img',
  },
  {
    titleKey: 'dataLayersAdditionallayersItems2',
    value: '7',
    tooltipContentKey: 'dataAdditionalLayersTooltip2',
    image: 'layer7Img',
  },
  {
    titleKey: 'dataLayersAdditionallayersItems3',
    value: '8',
    tooltipContentKey: 'dataAdditionalLayersTooltip3',
    image: 'layer8Img',
  },
];
